import React, { useState } from 'react';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDClickableText, FDStack,
} from '@facet-wealth/design';
import HoldingCard from 'Components/UI/HoldingCard/HoldingCard';
import PropTypes from 'prop-types';

const HoldingCardGroup = ({ holdingsGroup, categoryIDToCategoryMap, filteredCategories }) => {
  const [open, setOpen] = useState(false);
  return (
    <FDStack direction={'column'}>
      <FDAccordion expanded={open} onChange={() => setOpen(!open)}>
        <FDAccordionTitle>
          <FDClickableText appearance={'standalone'} label={holdingsGroup.name} />
        </FDAccordionTitle>
        <FDAccordionDetails>
          {holdingsGroup.holdings.map((holding) => {
            const category = categoryIDToCategoryMap.get(holding.attr('tickerClassification'));
            return (
              <HoldingCard
                key={holding.id()}
                holdingResource={holding}
                holdingClassificationColor={category.color}
                expandedByDefault={filteredCategories.length === 1}
              />
            );
          })}
        </FDAccordionDetails>
      </FDAccordion>

    </FDStack>
  );
};

HoldingCardGroup.defaultProps = {};

HoldingCardGroup.propTypes = {
  holdingsGroup: PropTypes.object.isRequired,
  categoryIDToCategoryMap: PropTypes.instanceOf(Map).isRequired,
  filteredCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export { HoldingCardGroup };
